import { AcquisitionCountrySelection, COUNTRY_CODE } from "consts";

export const formatAcquisitionZipForRequest = (country: AcquisitionCountrySelection, zip: string): string => {
  const trimmedZip = zip.trim();

  if (country === COUNTRY_CODE.POLAND && /^\d{5}$/.test(trimmedZip)) {
    return `${trimmedZip.slice(0, 2)}-${trimmedZip.slice(2)}`;
  }

  return trimmedZip;
};
